import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    initializing: true, // 初始化
    groupInitializing: {}, // 字段组分段请求数据，请求过的设为 false,
    fileDetailUser: null, // 档案详情人员
    groups: [], // 字段组
    fieldItems: [], // 字段 groupBy 字段组
    fileDetailGroup: [], // 显示的字段大组 根据 enabled 情况进行过滤
    itemsVal: [], // 字段值 groupBy 字段组
    groupEditable: [], // 字段组是否显示编辑按钮 （根据是否拥有可编辑字段判断）
    customItemsVal: null, // 自定义字段值

    editAvatarModalVisible: false, // 编辑头像 modal

    editOptionModalVisible: false, // 编辑选项
    editOptionModalLoading: false, // 编辑选项 loading
    editOptionData: {
        group: null, // 所属字段组
        itemCode: null, // 字段 code
        category: null, // 字段选项字典分类
        name: null, // 字段名称
        options: null, // 字段选项
    },

    editGroupKey: null, // 正在编辑的字段组的key
    editGroupRef: null, // 正在编辑的字段组的ref，scrollTo用
    editLoading: false, // 保存编辑时的loading

    secondmentReviewForms: null, // 借调评价模板 {formId: [item]} 用于字段渲染

    inviteFieldsModalVisible: false, // 邀请填写选择字段
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
